// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/** Toggleable filter chip: outline when off, solid ink when selected. */
export const FilterPill = React.forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, 'variant' | 'size'> & { selected: boolean }
>(({ selected, className, ...props }, ref) => (
  <Button
    ref={ref}
    type="button"
    variant="outline"
    size="sm"
    aria-pressed={selected}
    className={cn(
      'h-11 rounded-full md:h-8',
      selected
        ? 'border-transparent bg-foreground text-background hover:bg-foreground/90 hover:text-background'
        : 'text-muted-foreground',
      className,
    )}
    {...props}
  />
));
FilterPill.displayName = 'FilterPill';
